import { useQuery } from 'react-query';
import { apiCall } from '../../../../_services/apiCall';
import config from '../../../../config/config';

const fetchUsers = async () => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}getAllUser`,
    {},
    {},
    'GET'
  );
  return response?.data?.data || [];
};

export const useUsers = () => {
  return useQuery('users', fetchUsers, {
    staleTime: 10,
    cacheTime: 10,
    refetchOnWindowFocus: false
  });
};
